/* eslint-disable react-hooks/exhaustive-deps */
import Check from "@mui/icons-material/Check";
import DoneIcon from "@mui/icons-material/Done";
import ScheduleIcon from "@mui/icons-material/Schedule";
import {
  Autocomplete,
  Box,
  CircularProgress,
  Container,
  Grid,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { green } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { Divider, Select, DatePicker } from "antd";
import Loader from "components/custom/Loader";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import LocationVisitsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard2";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard4";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import useApiRequest from "utils/Apirequest";
import InfoCard from "../location_mgmt/components/Infocard";
import { getDecodedUserData } from "utils/Constant";
import dayjs from "dayjs";


const { RangePicker } = DatePicker;

const QontoStepIconRoot = styled("div")(({ theme }) => ({
  color: "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  "& .QontoStepIcon-completedIcon": {
    color: "#784af4",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  ...theme.applyStyles("dark", {
    color: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: "#784af4",
      },
    },
  ],
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: ownerState.completed
    ? green[500]
    : ownerState.active
      ? "yellow"
      : "red",
}));

function ColorlibStepIcon(props) {
  const { active, completed, icon, className } = props;

  const icons = {
    1: <DoneIcon />,
    2: <DoneIcon />,
    3: <DoneIcon />,
    4: <ScheduleIcon />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  textTransform: "none",
  fontWeight: 500,
  padding: "7px 18px",
  borderRadius: 999,
  border: `1px solid ${theme.palette.mode === "dark"
    ? "rgba(255, 99, 99, 0.3)"
    : "rgba(220, 38, 38, 0.35)"
    }`,
  color: theme.palette.text.primary,
  background:
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.04)"
      : "rgba(0,0,0,0.02)",
  transition: "all 0.25s ease",

  "&:hover": {
    background:
      theme.palette.mode === "dark"
        ? "rgba(255, 99, 99, 0.12)"
        : "rgba(220, 38, 38, 0.08)",
    borderColor: theme.palette.error.main,
  },

  "&.Mui-selected": {
    background: "linear-gradient(135deg, #EC4B48, #ef4444)",
    color: "#fff",
    fontWeight: 600,
    borderColor: "#ef4444",
    // boxShadow:
    //   theme.palette.mode === "dark"
    //     ? "0 0 0 1px rgba(239,68,68,0.5), 0 8px 18px rgba(239,68,68,0.35)"
    //     : "0 4px 12px rgba(239,68,68,0.35)",
  },

  "&.Mui-selected:hover": {
    background: "linear-gradient(135deg, #b91c1c, #dc2626)",
  },
}));

const Analytics_report = () => {
  const [converted, setConverted] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [converted1, setConverted1] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [convertedLocation, setConvertedLocation] = useState([]);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [timeRange, setTimeRange] = useState("today");
  const { Option } = Select;
  const [chargerPerformance, setChargerPerformance] = useState({});
  const [energyLoad, setEnergyLoad] = useState({});
  const [driverBehaviour, setDriverBehaviour] = useState({});
  const [driverKPI, setDriverKPI] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [financialdata, setFinancialData] = useState({});
  const [sustainability, setSustainability] = useState({});
  const navigate = useNavigate();

  const [dateRange, setDateRange] = useState(null);
  const [isCustomRange, setIsCustomRange] = useState(false);
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loadingLocations, setLoadingLocations] = useState(false);
  const [locationsFetched, setLocationsFetched] = useState(false);

  const apiRequest = useApiRequest();


  const fetchLocations = async () => {
    setLoadingLocations(true);
    const { data } = await apiRequest('get', 'charger-locations', null,
      {},
      {}, false
    ) || {};
    if (data?.status || data?.success) {
      setLocations(data?.data);
      setLocationsFetched(true);
      setLoadingLocations(false);
    }
    else {
      setLoadingLocations(false);
    }
  }


  const getPayload = () => {
    const basePayload = {
      timezone: process.env.REACT_APP_TIMEZONE,
      currency: process.env.REACT_APP_CURRENCYCODE,
    };

    let payload = { ...basePayload };

    if (isCustomRange && dateRange) {
      payload.start = dateRange[0].format("YYYY-MM-DD");
      payload.end = dateRange[1].format("YYYY-MM-DD");
      payload.filter = 'custom';
    } else {
      payload.filter = timeRange;
    }

    if (selectedLocation) {
      payload.locationId = selectedLocation?._id;
    }

    return payload;
  };

  const ALL_OPTION = {
    _id: "all",
    locationName: "All Locations",
  };

  const locationOptions = useMemo(() => {
    return [ALL_OPTION, ...(locations || [])];
  }, [locations]);


  useEffect(() => {
    setIsLoading(true);
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
    (async () => {
      const payload = getPayload();
      const { data } =

        (await apiRequest(
          "post",
          "session/summary",
          payload,
          {},
          {}
        )) || {};

      setChargerPerformance(data?.data?.chargerStationPerformance);

      const convertedData =
        data?.data?.chargerStationPerformance?.topPerformingChargers?.map(
          (item) => ({
            name: item?.chargerId,
            energy: item?.chargerName || item?.chargerId,
            revenue: item?.totalEnergyDelivered,
            visits: item?.totalSessions,
            color: "blue",
          })
        );
      const convertedData1 =
        data?.data?.driverBehaviorKPIs?.topDriversByEnergyConsumption?.map(
          (item) => ({
            name: item?.driverPhone,
            energy: item?.totalEnergyDelivered,
            visits: item?.totalSessions,
          })
        );
      const convertedData2 =
        data?.data?.driverBehaviorKPIs?.mostFrequentChargingLocations?.map(
          (item) => ({
            name: item?.locationId,
            visits: item?.sessionCount,
          })
        );
      setConverted(convertedData);
      setConverted1(convertedData1);
      setConvertedLocation(convertedData2);
      setEnergyLoad(data?.data?.energyAndLoadKPIs);
      setDriverBehaviour(data?.data?.driverBehaviorKPIs);
      setDriverKPI(data?.data?.driverKPIs);
      setFinancialData(data?.data?.financialOperationalKPIs);
      setSustainability(data?.data?.sustainabilityKPIs);
      setIsLoading(false);
    })();
  }, [timeRange, dateRange, isCustomRange, selectedLocation]);

  const headers = [
    { label: "#", flex: 0.2, align: "center" },
    { label: "Charger ID", flex: 0.6 },
    { label: "Charger Name", flex: 0.6 },
    { label: "Energy Dispersed", flex: 0.4, },
    { label: "Total Sessions", flex: 0.4, },
  ];

  const disableTodayAndFuture = (current) => {
    return current && current >= dayjs().startOf("day");
  };



  const handleRangeChange = (value) => {
    setTimeRange(value);
    setIsCustomRange(false);
    setDateRange(null);
    setIsLoading(true);
  };

  const handleDateRangeChange = (dates) => {
    if (dates && dates.length === 2) {
      setDateRange(dates);
      setIsCustomRange(true);
      setTimeRange(null);
      setIsLoading(true);
    } else {
      setDateRange(null);
      setIsCustomRange(false);
    }
  };

  return isLoading ? (
    <Loader />
  ) : (
    <Container
      maxWidth="lg"
      style={{
        backgroundColor: darkMode ? "#202940" : "#F0F0F0",
        color: darkMode ? "#ffffff" : "#000000",
      }}
    >
      <Box sx={{ my: 4 }}>
        <Grid container spacing={3}>

          <Grid item xs={12}>
            <MDTypography
              variant="h6"
              px={1}
              mb={2}
              sx={{
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontSize: "24px",
                fontWeight: 600,
                lineHeight: "36px",
              }}
            >
              Charger Station Performance
            </MDTypography>
          </Grid>
          <Grid item xs={12}>
            <MDBox
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                width: "100%",
                flexWrap: "wrap",
              }}
            >
              <Autocomplete
                options={locationOptions}
                loading={loadingLocations}
                getOptionLabel={(option) => option.locationName || ""}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                value={selectedLocation}
                onChange={(event, newValue) => {
                  setSelectedLocation(newValue);
                }}
                onOpen={() => {
                  if (!locationsFetched) fetchLocations();
                }}
                sx={{ minWidth: 240, flexGrow: 1 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Location"
                    size="small"
                  />
                )}
              />

              <ToggleButtonGroup
                value={!isCustomRange ? timeRange : null}
                exclusive
                size="small"
                onChange={(e, newValue) => {
                  if (newValue !== null) {
                    handleRangeChange(newValue);
                  }
                }}
                sx={{
                  opacity: isCustomRange ? 0.6 : 1,
                }}
              >
                <StyledToggleButton value="today">
                  Today
                </StyledToggleButton>

                <StyledToggleButton value="yesterday">
                  Yesterday
                </StyledToggleButton>

                <StyledToggleButton value="weekly">
                  Last Week
                </StyledToggleButton>

                <StyledToggleButton value="last30">
                  Last Month
                </StyledToggleButton>
              </ToggleButtonGroup>


              <RangePicker
                value={isCustomRange ? dateRange : null}
                onChange={handleDateRangeChange}
                format="YYYY-MM-DD"
                style={{ height: 36, minWidth: 260 }}
                placeholder={["Start Date", "End Date"]}
                disabledDate={disableTodayAndFuture}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} mt={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4} >
                <InfoCard
                  value={chargerPerformance?.totalSessions}
                  label="Total Charging Session"
                />
              </Grid>

              {/* <Grid item xs={12} sm={6} md={6} lg={3}>
                <InfoCard
                  value={chargerPerformance?.chargerUtilizationRate}
                  label="Charger Utilization Rate (%)"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={3}>
                <InfoCard
                  value={financialdata?.idleTime}
                  label="Idle Time (%)"
                />
              </Grid> */}
              <Grid item xs={12} sm={6} md={4}>
                <InfoCard
                  value={energyLoad?.energyCost}
                  label="Total Energy Cost"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoCard
                  value={energyLoad?.totalEnergyDelivered}
                  label="Total Energy Delivered (kWh)"
                />
              </Grid>



            </Grid>
          </Grid>

        </Grid>
        <Grid container spacing={3} mt={2}>
          <Grid item xs={12} md={12} lg={4}>
            <Grid item xs={12} md={12} py={2}>
              <ComplexStatisticsCard
                color="dark"
                icon="weekend"
                title="Number of Remote Start/Stop Events"
                title1="Start"
                title2="Stop"
                count1={
                  chargerPerformance?.remoteStartStopEvents?.remoteStartCount
                }
                count2={
                  chargerPerformance?.remoteStartStopEvents?.remoteStopCount
                }
                percentage={{
                  color: "success",
                  amount: "+55%",
                  label: "than lask week",
                }}
              />
            </Grid>
            <Grid item xs={12} md={12} py={2}>
              <ComplexStatisticsCard
                color="dark"
                icon="weekend"
                title="Battery SOC at Start vs End "
                title1="Start"
                title2="End"
                count="0"
                count1={energyLoad?.batterySocAnalysis?.avgStartSoc}
                count2={energyLoad?.batterySocAnalysis?.avgEndSoc}
                percentage={{
                  color: "success",
                  amount: "+55%",
                  label: "than lask week",
                }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} lg={8}>
            <LocationVisitsCard
              title="Top Performing Chargers"
              items={converted}
              headers={headers}
              height="420px"
            />
          </Grid>
        </Grid>

        <Divider
          dashed
          style={{
            borderColor: "rgba(0, 0, 0, 0.15)",
          }}
        />

        <Grid item xs={12}>
          <MDTypography
            variant="h6"
            px={1}
            mb={1}
            style={{
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              fontSize: "24px",
              fontWeight: "600",
              lineHeight: "36px",
            }}
          >
            Average Key Figures
          </MDTypography>
          <Grid item xs={12} mt={3}>
            <Grid container spacing={3}>



              <Grid item xs={12} sm={6} md={3}>
                <InfoCard
                  value={energyLoad?.averageEnergyPerSession}
                  label="Average Energy per Session"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <InfoCard
                  value={energyLoad?.avgSessionsPerCharger}
                  label="Average Sessions per Charger"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <InfoCard
                  value={chargerPerformance?.averageSessionDuration}
                  label="Average Charging Session Duration"
                />
              </Grid>
              <Grid
                item
                xs={12} sm={6} md={6} lg={3}

              >
                <InfoCard
                  value={driverKPI?.chargingEfficiencyIndex}
                  label="Charging Efficiency Index"
                />
              </Grid>


            </Grid>
          </Grid>

        </Grid>
        <Divider
          dashed
          style={{
            borderColor: "rgba(0, 0, 0, 0.15)",
          }}
        />


        <Grid item xs={12}>
          <MDTypography
            variant="h6"
            px={1}
            mb={1}
            style={{
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              fontSize: "24px",
              fontWeight: "600",
              lineHeight: "36px",
            }}
          >
            Financial & Operational KPIs
          </MDTypography>
          <Grid item xs={12} mt={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <InfoCard
                  value={financialdata?.avgRevenuePerCharger}
                  label="Cost Collected (AED) per Charger"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoCard
                  value={financialdata?.avgRevenuePerSession}
                  label="Average Cost per Session"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoCard
                  value={financialdata?.costPerKWh}
                  label="Cost per kWh Delivered "
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Divider
          dashed
          style={{
            borderColor: "rgba(0, 0, 0, 0.15)",
          }}
        />
        {/* <Grid item xs={12}>
          <MDTypography
            variant="h6"
            px={1}
            mb={1}
            style={{
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              fontSize: "24px",
              fontWeight: "600",
              lineHeight: "36px",
            }}
          >
            Driver KPIs
          </MDTypography>
          <Grid item xs={12} mt={2}>
            <Grid container spacing={3}>

              <Grid item xs={12} sm={6} md={3} >
                <InfoCard
                  value={driverKPI?.reservationNoShowRate}
                  label="Reservation No Show Rate"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3} >
                <InfoCard
                  value={driverKPI?.onTimeArrivalPercentage}
                  label="On-Time Arrival Percentage"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3} >
                <InfoCard
                  value={driverKPI?.idleTimePerSession}
                  label="Idle Time Per Session"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} >
                <InfoCard
                  value={driverKPI?.avgWaitTime}
                  label="Average Wait Time"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Divider
          dashed
          style={{
            borderColor: "rgba(0, 0, 0, 0.15)",
          }}
        /> */}
        <Grid item xs={12}>
          <MDTypography
            variant="h6"
            px={1}
            mb={1}
            style={{
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              fontSize: "24px",
              fontWeight: "600",
              lineHeight: "36px",
            }}
          >
            Sustainability & ESG KPIs
          </MDTypography>
          <Grid item xs={12} mt={3}>
            <Grid container spacing={3}>

              <Grid item xs={12} sm={6} md={4}>
                <InfoCard
                  value={sustainability?.equivalentTreesPlantedPerYear}
                  label="Equivalent Trees Planted / Year"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <InfoCard
                  value={sustainability?.avgCO2SavingsPerSession}
                  label="Average CO₂ Savings per Session"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <InfoCard
                  value={sustainability?.totalCO2Saved}
                  label="Total CO₂ Savings"
                />
              </Grid>

            </Grid>
          </Grid>

        </Grid>
      </Box >
    </Container >
  );
};

export default Analytics_report;
